module.exports = __webpack_public_path__ + "resources/img/equipment_tab2_img4_m.4b1c6a4eb882f5719b26898cdb2b61b4.jpg";